import { combineReducers } from "redux";
import fetchReducer from "./fetchPostReducer";
import fetchCategoriesReducer from "./fetchCategoriesReducer";
import fetchArticleReducer from "./fetchArticleReducer";
import fetchRecommendedPostsReducer from "./fetchRecommendedPostsReducer";
import fetchBasicInfoReducer from "./fetchBasicInfoReducer";
import fetchAboutInfoReducer from "./fetchAboutInfoReducer";
import fetchSnsInfoReducer from "./fetchSnsInfoReducer";
export default combineReducers({
  fetchReducer,
  fetchCategoriesReducer,
  fetchArticleReducer,
  fetchRecommendedPostsReducer,
  fetchBasicInfoReducer,
  fetchAboutInfoReducer,
  fetchSnsInfoReducer,
});
